module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fb4bf7e78883c67f5ab1a88278b53ebc.png";